var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"badge"},[(_vm.icon)?_c('i',{class:`mdi mdi-${_vm.icon}`}):_vm._e(),_c('p',{staticClass:"badge-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }